import React from 'react';
import { View } from '@dbk/ui-react-utils';
import cx from 'classnames';
import Alert from '../common/alert';
import AppFooter from './app-footer';
import AppIdle from '../common/app-idle';
import BackLink from '../../components/common/back-link';
import { ROUTES } from '../../constants';
import AppRMAdmin from './app-rm-admin';

const RMPortal = (props) => {
  const {
    ui: {
      history: {
        currentLocation: { pathname },
      },
    },
    i18n: { messages },
    children
  } = props;

  const isLandingPage = pathname.endsWith(ROUTES.RMACCESS.DOC_LANDING_PAGE);
  const isRMWelcomePage = pathname.endsWith('/rmAccess');

  const pageContentClasses = cx('content contentHeightRM');

  return (
    <View className={'app-container'}>
      {<AppRMAdmin />}
      { <div className="app-header">
        <div className="portfolio-bar">
          <div className="portfolio-row">

            <div className="small-2 column text-left">
              <BackLink messages={messages} />
            </div>
          </div>
        </div>
      </div>}
      {<div className="app-header-placeholder" />}
      <View className={pageContentClasses}>
        {children}
        {/* Add extra padding at bottom for mobile layout */}
        {<div className="app-header-placeholder" />}
      </View>
      { <AppFooter />}
      {<AppIdle />}
      <Alert />
    </View>
  );
};

export default RMPortal;
